import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
var DuelTabs = function DuelTabs() {
  return import('@/components/organisms/DuelTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
import Nl2br from 'vue-nl2br';
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
export default {
  components: {
    DuelTabs: DuelTabs,
    PrimeIcon: PrimeIcon,
    ExternalLink: ExternalLink,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    LazyImage: LazyImage,
    Modal: Modal
  },
  data: function data() {
    return {
      isTutorialModalShown: false
    };
  },
  computed: {
    userInfo: function userInfo() {
      return useRankMatchStore().getMyUserInfo;
    },
    getRankMatchName: function getRankMatchName() {
      return useRankMatchMaster().getRankMatchName;
    },
    getRankMatchClass: function getRankMatchClass() {
      return useRankMatchMaster().getRankMatchClass;
    },
    getShownRankMatchMasters: function getShownRankMatchMasters() {
      return useRankMatchStore().getShownRankMatchMasters;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return useRankMatchStore().fetchMyUserInfos();
          case 2:
            // チュートリアル
            if (!window.localStorage.getItem('bfh:rankMatchTutorial')) {
              _this.isTutorialModalShown = true;
              window.localStorage.setItem('bfh:rankMatchTutorial', true);
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getCupPeriodStr: function getCupPeriodStr(period) {
      var sinceStr = this.$dayjs(period.since * 1000).format('LLL');
      var untilStr = this.$dayjs(period.until * 1000).format('LLL');
      return "".concat(sinceStr, " - ").concat(untilStr);
    },
    clickConfirm: function clickConfirm(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.userInfo(id).isjoined) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return _this2.$router.push(_this2.localePath({
                name: 'rankmatch-rankMatchId-index',
                params: {
                  rankMatchId: id
                }
              }));
            case 3:
              _context2.next = 7;
              break;
            case 5:
              _context2.next = 7;
              return _this2.$router.push(_this2.localePath({
                name: 'rankmatch-rankMatchId-index-detail',
                params: {
                  rankMatchId: id
                }
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    isShownIcon: function isShownIcon(rankMatchMaster) {
      return this.userInfo(rankMatchMaster.rankMatchId).isjoined || this.getRankMatchClass(rankMatchMaster.rankMatchId) || rankMatchMaster.rules.isPrimeOnly;
    }
  }
};